import {isSavedCompetitorAdCanvasId} from './savedCompetitorAd';
import {isSavedAssetCanvasId} from './savedAssetPlacement';
/** Saved originals keep record identity even when two ads share a media asset. */
export interface SavedBrandAdReference {
  clientId: string;
  src: string;
  brandId: number;
  savedAdId: number;
  source: 'saved_public_brand_ad_analysis';
  externalId?: string;
  mediaType?: string;
  originalHeadline?: string;
  originalCopy?: string;
}

export function savedBrandAdCanvasId(brandId: number, adId: number, revision?: string): string {
  return `saved-brand-ad-${brandId}-${adId}${revision ? `-${revision}` : ''}`;
}

export function isSavedBrandAdCanvasId(id: unknown): id is string {
  return typeof id === 'string' && /^saved-brand-ad-\d+-\d+(?:-[a-f0-9]{12})?$/.test(id);
}

/** Preserve selected record identity, including generated ads and manual duplicates.
 * Legacy img-gen aliases can precede their canonical server row; only those use URL resolution. */
export function savedBrandAdSelectionReferences(selectedIds: string[], images: Array<{id:string;src:string}>, referenceUrls: string[]): Array<{clientId:string;src:string}> {
  return Array.from(new Set(selectedIds)).filter(id => !id.startsWith('img-gen-')).flatMap(clientId => {
    const image=images.find(image=>image.id===clientId);
    return image && referenceUrls.includes(image.src)?[{clientId,src:image.src}]:[];
  });
}

export function isManualDuplicateCanvasId(id:unknown):id is string {return typeof id==='string'&&/^img-dup-(?:\d+|[0-9a-f-]{36})$/.test(id);}
/** Each accepted ordinary provider request is a separate image instance. */
export function isOrdinaryGeneratedCanvasId(id:unknown):id is string{return typeof id==='string'&&/^agent-img-[A-Za-z0-9_-]+$/.test(id);}
export function isDistinctCanvasImageId(id:unknown):id is string {return isOrdinaryGeneratedCanvasId(id)||isSavedBrandAdCanvasId(id)||isSavedCompetitorAdCanvasId(id)||isSavedAssetCanvasId(id)||isManualDuplicateCanvasId(id);}

export function canvasImageSourceKey(row: { clientId?: string; id?: string | number; src?: string | null; variantOfImageId?: number | null }): string | null {
  const clientId = row.clientId ?? row.id;
  if (isDistinctCanvasImageId(clientId)) return clientId;
  return row.src ? JSON.stringify([row.src, row.variantOfImageId ?? null]) : null;
}
